import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * /callback — Auth0 redirects users here after Universal Login.
 * The SDK processes the URL fragment in the background; once isLoading
 * flips to false our Auth0Provider's onRedirectCallback navigates the
 * user to the page they wanted (or /dashboard).
 */
export default function Callback() {
  const { isLoading, error } = useAuth0();

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-zinc-50"
      data-testid="auth-callback-page"
    >
      <div className="text-center">
        {error ? (
          <>
            <div className="display text-2xl font-black tracking-tight text-rose-600">
              Sign-in failed
            </div>
            <p className="mt-2 text-sm text-zinc-600 max-w-md mono">
              {error.message}
            </p>
            <a
              href="/"
              className="inline-block mt-6 bg-black text-white text-sm px-4 py-2 rounded-[4px] hover:bg-zinc-800"
              data-testid="callback-home"
            >
              Back home
            </a>
          </>
        ) : (
          <>
            <div className="display text-2xl font-black tracking-tight">
              Signing you in…
            </div>
            <p className="mt-2 text-sm text-zinc-500 mono">
              {isLoading ? "Verifying token" : "Redirecting"}
            </p>
            <div className="mt-6 inline-block w-6 h-6 border-2 border-zinc-300 border-t-black rounded-full animate-spin" />
          </>
        )}
      </div>
    </div>
  );
}
